import { matchPath, useLocation } from 'react-router'
import type { SparkyContextKind } from './types'

export interface SparkyContext {
  kind: SparkyContextKind
  dealId: string | null
  route: string
}

/**
 * Derive the context snapshot for a NEW conversation from the current route
 * (spec §2/§5): on `/preinvest/deals/:id` Sparky gets that deal's dossier;
 * everywhere else he falls back to the aggregated board overview (`page` is a
 * future extension point — unmapped routes deliberately map to `board`).
 * The snapshot is frozen at conversation creation, so navigating elsewhere
 * later never changes an existing chat's context.
 */
export function useSparkyContext(): SparkyContext {
  const location = useLocation()
  const dealMatch = matchPath('/preinvest/deals/:id', location.pathname)
  const dealId = dealMatch?.params.id ?? null
  return {
    kind: dealId !== null ? 'deal' : 'board',
    dealId,
    route: location.pathname,
  }
}

/** Key under which `SparkyHost` remembers the last conversation of a context. */
export function sparkyContextKey(context: SparkyContext): string {
  return context.kind === 'deal' && context.dealId !== null ? `deal:${context.dealId}` : 'board'
}
